export default {"src":"https://fishbrain.com/_next/static/media/montana.5196106d.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};